import React,{useState,useEffect,useRef} from "react";
import './classes/AppsByCountry.css';
import { configData } from "../config";
import Loading from './Loading';
import Select from 'react-dropdown-select';
import { Helmet } from 'react-helmet';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { DataGrid } from '@mui/x-data-grid';
 import { Link } from '@mui/material';
 import { format } from "date-fns";
import { Box, Pagination, PaginationItem } from '@mui/material';

const AppsByCountry = ()=>{
     const initialForm = () => {
  const params = new URLSearchParams(window.location.search);

  const defaultForm = {
    country: '',
    state: '',
    salesperson: '',
    course: '',
    payment: 'ALL',
    future_tasks: 'ALL',
    start_date: '',
    start_date_obj: null,
    end_date: '',
    end_date_obj: null,
    birthday_start_date: '',
    birthday_start_date_obj: null,
    birthday_end_date: '',
    birthday_end_date_obj: null,
    view: '',
    action:''
  };

  //  normal dates
  const queryStart = params.get("start_date");
  const queryEnd = params.get("end_date");

  // const startObj = queryStart && !isNaN(new Date(queryStart))
  //   ? new Date(queryStart + "T00:00:00")
  //   : null;

  // const endObj = queryEnd && !isNaN(new Date(queryEnd))
  //   ? new Date(queryEnd + "T00:00:00")
  //   : null;
  const startObj =
    queryStart
      ? new Date(queryStart.replace(/-/g, "/") + " 00:00:00")
      : null;

  const endObj =
    queryEnd
      ? new Date(queryEnd.replace(/-/g, "/") + " 00:00:00")
      : null;

  //  birthday dates
  const queryBdayStart = params.get("birthday_start_date");
  const queryBdayEnd = params.get("birthday_end_date");

  // const bdayStartObj = queryBdayStart && !isNaN(new Date(queryBdayStart))
  //   ? new Date(queryBdayStart + "T00:00:00")
  //   : null;

  // const bdayEndObj = queryBdayEnd && !isNaN(new Date(queryBdayEnd))
  //   ? new Date(queryBdayEnd + "T00:00:00")
  //   : null;

  const bdayStartObj =
    queryBdayStart
      ? new Date(queryBdayStart.replace(/-/g, "/") + " 00:00:00")
      : null;

  const bdayEndObj =
    queryBdayEnd
      ? new Date(queryBdayEnd.replace(/-/g, "/") + " 00:00:00")
      : null;

  const queryCountry = params.get("country");

  const countryObj = queryCountry
    ? [{ label: queryCountry, value: queryCountry }]
    : [{ label: 'ALL', value: 'ALL' }];
    // console.log("Country Object:", countryObj);

  const queryView = params.get("view") || ''; 

  return {
    ...defaultForm,
    payment: params.get("payment") || defaultForm.payment,
    future_tasks: params.get("future_tasks") || defaultForm.future_tasks,
    country: queryCountry || defaultForm.country,
    selectedcountry: countryObj,
    state: params.get("state") || defaultForm.state,
    course: params.get("course") || defaultForm.course,
    salesperson: params.get("salesperson") || defaultForm.salesperson,

    //  normal dates
    start_date: startObj ? queryStart : '',
    start_date_obj: startObj,

    end_date: endObj ? queryEnd : '',
    end_date_obj: endObj,

    //  birthday dates
    birthday_start_date: bdayStartObj ? queryBdayStart : '',
    birthday_start_date_obj: bdayStartObj,

    birthday_end_date: bdayEndObj ? queryBdayEnd : '',
    birthday_end_date_obj: bdayEndObj,

    view: queryView,
    action:''
  };
};       
      const [formData, setFormData] = useState(initialForm());
      const [appliedFormData, setAppliedFormData] = useState(initialForm());
      const [submittedData, setSubmittedData] = useState(null);
      const [isLoading, setIsLoading] = useState(true);
      const [countriesList, setCountriesList] = useState([]);
      const [statelist, setStateList] = useState({});

      const init = initialForm();  
      // const [selectedcountry, setSelectedCountry] = useState([{label: 'ALL', value: 'ALL' }]);
      const [selectedcountry, setSelectedCountry] = useState(init.selectedcountry);
      const [selectedState, setSelectedState] = useState('');
       
      const [course, setCourseList] = useState({});
      const [salespersonList, setSalespersonList] = useState({});
      const [formErrors, setFormErrors] =useState({});
      const [isSubmitted, setIsSubmitted] = useState(false);

      const isMounted = useRef(false);
         const app_url = configData.APP_URL;
        const startDateRef = useRef(null);
       const endDateRef = useRef(null);
         const BirthstartDateRef = useRef(null);
       const BirthendDateRef = useRef(null);
        useEffect(() => {
           Promise.all([
          retrieveCountriesList(),
          retrieveStateList(),
          getsalespersonlist(),
          getcourselist(),
          ]).then(() => {
     
            setIsLoading(false);
          })
        }, []);
        const handleOpen = () => {
    setSelectedCountry([]);
    setFormData(prevState => ({
      ...prevState,
      country:''
    }));

  };
   async function retrieveStateList() {
    const statelistresponse = await fetch(
      app_url+'smwwstates/getstatelist',
      {
        method: "GET",

        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const statelistdata = await statelistresponse.json();
    
    const statelist = {};
    Object.keys(statelistdata.data.result).forEach(function(key) {
      
      statelist[key] = statelistdata.data.result[key];
    
    });
    setStateList(statelist);
   
  }
  async function retrieveCountriesList() {
    const countrieslistresponse = await fetch(
      app_url+'smwwcountries/getreportcountrieslist',
      {
        method: "GET",

        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const countrieslistdata = await countrieslistresponse.json();

    // setCountriesList(countrieslistdata.data.result);
    const countries = Array.isArray(countrieslistdata?.data?.result)
    ? countrieslistdata.data.result
    : [];

  setCountriesList([
    { value: "ALL", label: "All" },
    ...countries
  ]);
    
    
  }
  async function getsalespersonlist() {
    
         try {
            const response = await fetch(
                app_url+'user/getsalespersonlistwithunassigned',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setSalespersonList(responsedata.data.result);
               
            } 
        } catch (err) {
            
         }
        
  }
   async function getcourselist() {
    
         try {
            const response = await fetch(
                app_url+'report/getajaxcourselist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setCourseList(responsedata.data.result);
               
            } 
        } catch (err) {
            
         }
        
  }
    
    const payment = [
        {value:'ALL',label:'ALL'},
        {value:'Some',label:'Some Payment'},
        {value:'No',label:'No Payment'}
    ];
    const futureTasks = [
        {value:'ALL',label:'ALL'},
        {value:'Some',label:'Has Tasks'},
        {value:'No',label:'No Tasks'}
    ];
    const columns = [
    {
    field: 'field_date_of_app',
    headerName: 'Date of App',   
    flex:1,  
    sortable: false,
    // minWidth:170,
    cellClassName:'date_of_app_column',headerClassName:'date_of_app_header',
  },
  {
    field: 'first_name',
    headerName: 'First Name',      
    flex:1,
    sortable: false,
    // minWidth:140,
    cellClassName:'first_name_column',headerClassName:'first_name_header',
  },
  {
    field: 'last_name',
    headerName: 'Last Name',    
    flex:1,
    sortable: false,
    // minWidth:140,
    cellClassName:'last_name_column',headerClassName:'last_name_header',
  },
    {
    field: 'email',
    headerName: 'E-Mail',
    flex:1,
    sortable: false,
    // minWidth:220,
    cellClassName:'email_column',headerClassName:'email_header', 
     renderCell: (params) => (
    <Link href={params.row.url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.email}
      </Link>
  ),
    
  },
  {
    field: 'applied_courses',
    headerName: 'Applied to (Courses)', 
    sortable: false,  
    flex:1,
    // minWidth:230,
    cellClassName:'applied_courses_column',headerClassName:'applied_courses_header',
  },
  {
    field: 'salesperson',
    headerName: 'Salesperson',   
    flex:1,
    sortable: false,
    //  minWidth:150,
    cellClassName:'salesperson_column',headerClassName:'salesperson_header',
  },
  {
    field: 'country',
    headerName: 'Country',   
    flex:1,
    sortable: false,
    //  minWidth:150,
    cellClassName:'country_column',headerClassName:'country_header',
  },
  {
    field: 'state',
    headerName: 'State',   
    flex:1,
    sortable: false,
    // minWidth:150,
    cellClassName:'state_column',headerClassName:'state_header',
  },

  {
    field: 'sortflags',
    headerName: 'Sortflag',   
    flex:1,
    sortable: false,
    // minWidth:130,
    cellClassName:'sort_flag_column',headerClassName:'sort_flag_header',
  },
  {
    field: 'last_task_date',
    headerName: 'Last Task Date',   
    flex:1,
    sortable: false,
    //  minWidth:180,
    cellClassName:'last_task_date_column',headerClassName:'last_task_date_header',
  },

];
const [rows, setRows] = React.useState([]);
  const [rowCount, setRowCount] = React.useState(0);
  const [paginationModel, setPaginationModel] = React.useState({ pageSize: 50 });
  const [sortModel, setSortModel] = React.useState([]);
  const [filterModel, setFilterModel] = React.useState({ items: [] });
  const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData(prev => ({
    ...prev,
    [name]: value
  }));
};

// const handleDateChange = (date) => {
//        const formattedDate = date ? format(date, "yyyy-MM-dd") : '';
//            setFormData(prev => ({ ...prev, start_date: formattedDate }));
//          };
//       const handleEndDateChange = (date) => {
       
//        const formattedDate = date ? format(date, "yyyy-MM-dd") : '';
//             setFormData(prev => ({ ...prev, end_date: formattedDate }));
//       };
// const handleBirthDateChange = (date,name) => {
       
//        const formattedDate = date ? format(date, "yyyy-MM-dd") : '';
//        setFormData(prev => ({ ...prev, [name]: formattedDate }));
//       }; 
const handleDateChange = (date, field) => {
  setFormData(prev => ({
    ...prev,
    [`${field}_obj`]: date,                       // Date object for DatePicker
    [field]: date ? format(date, "yyyy-MM-dd") : '' // string for backend
  }));
};


  const validateDates = (formData) => {
    let errors = {};

    if (!formData.start_date) {
      errors.start_date = "Start date is required.";
    }

    if (!formData.end_date) {
      errors.end_date = "End date is required.";
    }

    if (formData.start_date && formData.end_date) {
      if (formData.end_date < formData.start_date) {
        errors.end_date = "Start date can't over end date.";
      }
    }

    return errors;
  };

    const [page, setPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(paginationModel.pageSize);
    const [totalItems, setTotalItems] = useState(0);
// Adjust the page controls
const totalPages = Math.ceil(totalItems / itemsPerPage);
const startIndex = (page - 1) * itemsPerPage;
const lastPageIndex = Math.min(startIndex + itemsPerPage, totalItems);

// Pagination controls
const goToNextPage = () => {
  setPage(prev => Math.min(prev + 1, totalPages));
};

const goToPrevPage = () => {
  setPage(prev => Math.max(prev - 1, 1));
};

const goToSpecificPage = (pageNumber) => {
  setPage(pageNumber);
};

// Render pagination controls based on totalPages

// function renderPaginationControls() {
//   const maxButtons = 10;
//   let startPage = Math.max(1, page - Math.floor(maxButtons / 2));
//   let endPage = Math.min(totalPages, startPage + maxButtons - 1);

//   if (endPage - startPage < maxButtons - 1) {
//     startPage = Math.max(1, endPage - maxButtons + 1);
//   }

//   const pageNumbers = [];
//   for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);

//   return (
//     <div>
//       {totalItems > itemsPerPage && (
//         <Box display="flex" justifyContent="center" mt={2}>
//           <Pagination
//             count={totalPages}
//             page={page}
//             onChange={(_, val) => {
//               setPage(val);  // Update page state
//               window.scrollTo(0, 0);  // Scroll to top on page change
//             }}
//             color="primary"
//             siblingCount={1}  // Optional: Adjusts the number of buttons displayed around the current page
//             boundaryCount={1}  // Optional: Adds boundary buttons for first and last page
//             shape="rounded"  // Optional: For rounded pagination buttons
//             renderItem={(item) => (
//               <PaginationItem
//                 {...item}
//                 sx={{
//                   fontWeight: item.page === page ? 'bold' : 'normal',
//                   color: item.page === page ? '#fff' : '#111',
//                   backgroundColor: item.page === page ? '#1976d2' : 'transparent',
//                   '&:hover': {
//                     backgroundColor: item.page === page ? '#1976d2' : '#f5f5f5',
//                   },
//                 }}
//               />
//             )}
//           />
//         </Box>
//       )}
//     </div>
//   );
// }
function renderPaginationControls() {
  const maxButtons = 10;
  let startPage = Math.max(1, page - Math.floor(maxButtons / 2));
  let endPage = Math.min(totalPages, startPage + maxButtons - 1);

  if (endPage - startPage < maxButtons - 1) {
    startPage = Math.max(1, endPage - maxButtons + 1);
  }

  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);

  return (
    <div style={{marginTop: "16px"}}>
      {totalItems > itemsPerPage && (
        <div className="us-agent-pagination" style={{ textAlign: 'center' }}>
          {page > 1 && (
            <>
              <button onClick={() => setPage(1)} className="report-pagination">« First</button>
              <button onClick={goToPrevPage} className="report-pagination">‹ Previous</button>
            </>
          )}

          {pageNumbers.map(num => (
            <button
              key={num}
              onClick={() => goToSpecificPage(num)}
              style={{
                fontWeight: num === page ? 'bold' : 'normal',
                color: num === page ? '#fff' : '#111',
                background: num === page ? '#1976d2' : 'none',
                border: "none"
              }}
              className="report-pagination"
            >
              {num}
            </button>
          ))}

          {page < totalPages && (
            <>
              <button onClick={goToNextPage} className="report-pagination">Next ›</button>
              <button onClick={() => setPage(totalPages)} className="report-pagination">Last »</button>
            </>
          )}
        </div>
      )}
    </div>
  );
}
   
      React.useEffect(() => {
        
   if(formData.start_date && formData.end_date) {
      const fetchData = async () => {
      // Simulate API call to your server
      // In a real application, replace this with your actual fetch logic
       try {
        setIsLoading(true);
      const response = await fetch(app_url+'report/appsbycountry', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          page: page-1,
          pageSize: itemsPerPage,
          sortModel,
          filterModel,
          // formData:appliedFormData
          formData: {
            ...appliedFormData,
            action: isSubmitted ? 'submit' : ''
          }
        }),
      });
      const data = await response.json();
      console.log(data.data.rows);
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
      setTotalItems(Number(data.data.totalRowCount));
      }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
            if (isSubmitted) {
              setIsSubmitted(false);
            }
          }
          
    };
    

    fetchData();
  }
      }, [ itemsPerPage, sortModel, filterModel, appliedFormData, page]); // Re-fetch data when these change 


useEffect(() => {
  setItemsPerPage(paginationModel.pageSize);
  setPage(1); // Reset to the first page whenever the pageSize changes
}, [paginationModel.pageSize]);    

const submitFormData = async (data) => {
  setSubmittedData(data);
  setAppliedFormData(data);
  setIsSubmitted(false);
  // try {
  //   setIsLoading(true);

  //   const response = await fetch(app_url + 'report/appsbycountry', {
  //     method: 'POST',
  //     headers: { 'Content-Type': 'application/json' },
  //     body: JSON.stringify({
  //       page: 0,
  //       pageSize: 50,
  //       sortModel,
  //       filterModel,
  //       formData: data
  //     }),
  //   });

  //   const res = await response.json();

  //   setRows(res.data.rows);
  //   setRowCount(res.data.totalRowCount);
  // } catch (error) {
  //   console.error('Error fetching data:', error);
  // } finally {
  //   setIsLoading(false);
  // }
};

  // Handle submit
  const handleSubmit = async (e) => {
    e.preventDefault(); // stop page reload

    const errors = validateDates(formData);

    if (Object.keys(errors).length > 0) {
      console.log("Validation errors:", errors);
      setFormErrors(errors); 
      return;
    }
    setFormErrors({});
  
    // Reset pagination state
    setPaginationModel({ pageSize: 50 });
    setPage(1);
    setSubmittedData(formData);
    setAppliedFormData({...formData});
    setIsSubmitted(true);
    //  try {
    //     setIsLoading(true);
    //   const response = await fetch(app_url+'report/appsbycountry', {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify({
    //        page: 0,
    //            pageSize: 50, 
    //       sortModel,
    //       filterModel,
    //       formData:formData
    //     }),
    //   });
    //   const data = await response.json();
    //   console.log(data.data.rows);
    //   setRows(data.data.rows);
    //   setRowCount(data.data.totalRowCount); // Server should return totalRowCount
    //   }  catch (error) {
    //         console.error('Error fetching data:', error);
    //       } finally {
    //         setIsLoading(false); // Set loading to false after fetch completes (success or error)
    //       }
    // console.log("Form submitted:", formData);


  };
  const handleExport = async (e) => {
    e.preventDefault(); // stop page reload

    const errors = validateDates(formData);

    if (Object.keys(errors).length > 0) {
      console.log("Validation errors:", errors);
      setFormErrors(errors); 
      return;
    }
    setFormErrors({});
   
     try {
        setIsLoading(true);
      const response = await fetch(app_url+'report/appsbycountryexport', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          
          formData:formData
        }),
      });
      const data = await response.json();
     const csvUrl = data.data.csvUrl;
      const urlParts = csvUrl.split('/');
        const fileName = urlParts[urlParts.length - 1];
                const link = document.createElement('a');
                link.href = csvUrl;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
      
      }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }


  };

useEffect(() => {
  const params = new URLSearchParams(window.location.search);

  if ([...params.keys()].length > 0) {
    const init = initialForm();

    setFormData(init);
    setSelectedCountry(init.selectedcountry); 

    submitFormData(init);              
  }
}, []);

    return(
           <>
            {isLoading ? (
              <Loading />
            ) : (
        <div id="main" className="reports-main">
                <Helmet>
                    <title>
                        Apps by Courses and Country and Date
                    </title>
                </Helmet>
            <div className="left"></div>
            <div className="center left-center">
                <div className="apps-by-country-container">
                <h1>Apps by Course and Country and Date</h1>
                <div className="messages warning">
                    &nbsp;&nbsp;Data available starting May 2003<br/><br/>
                    &nbsp;&nbsp;If you're looking up large amounts of data, please wait for the report to load.<br/><br/>
                    &nbsp;&nbsp;If your search is not successful (i.e. system crashes), try a shorter date range.
	            </div> 
                <div className="messages_details">
                        Salesperson –&gt; Unassigned: Will pull unassigned users and users assigned to anyone other than the following:
                        <ul >
                            <li>Adam Klimek</li>
                            <li>Alyssa Rutherford</li>
                            <li>Chuck Patterson</li>
                            <li>DeWayne Penney</li>
                            <li>Jeff Brodie</li>
                            <li>Jon LaForce</li>
                            <li>Lynn Lashbrook</li>
                        </ul>	
                 </div> 
                 <form onSubmit={handleSubmit}>
                    <div>
                       <label htmlFor="country">Country</label>                        
                            <Select                              
                             id="country" name="country" className='select-country smww-appn'
                             searchable={true}                             
                             clearable={true} 
                             clearOnBlur={true} 
                             clearOnSelect={true}
                             backspaceDelete={true}                              
                             style={{backgroundColor:'#ffffff', borderRadius: 5}}                                                
                             options={countriesList}                             
                             onChange={(val) => {
                               if(val.length == 0) {
                                 console.log(val);
                               }
                               else{
                                 setSelectedCountry(val);
                              handleChange(
                                 { target: { value: val[0]['value'], name: 'country' } }
                               )
                               
                               }}
                             }
                             onDropdownOpen={handleOpen}
                             values={selectedcountry}                             
                             />                      
                        </div>
                        <div>
                          <label htmlFor="state-field">State: </label>
                          <select className='' id="state-field" name="state" value={formData.state}  
                          onChange={handleChange} 
                          >
                       <option value="ALL">ALL</option>
                        {Object.keys(statelist).map(state => {
                        return <option key={statelist[state].name} value={statelist[state].name}>{statelist[state].name}</option>
                        })}
                        </select>                       
                      </div>
                     <div>
                        <label>Salesperson: </label>
                        
                        <select
                        className=' '
                        name="salesperson"
                        value={formData.salesperson}
                        onChange={handleChange}
                                                        >
                            <option value="ALL">ALL</option>
                        {salespersonList.length > 0 && (
                            <>
                            {salespersonList.map((item, index) => {
                                return <>
                                    {item['uid'] != null && (
                                    <><option value={item['uid']}>{item['name']}</option></>
                                    )}
                                </>
            
                            })}  
    
                            </>
                        )}
                        
                        </select>

                    </div>
                    <div>
                        <label>Products</label>
                        <select name="course" value={formData.course} 
                        onChange={handleChange}
                        ><option value="ALL">ALL</option>
                            {course.length > 0 && (
                            <>
                            {course.map((item, index) => {
                                return (
                                    <><option value={item['course_code']}>{item['course_code']}</option></>)
                                    
            
                            })}  
    
                            </>
                        )}
                        </select>
                        </div>
                    <div>
                        <label>Payment Status:</label>
                        <select  name="payment" value={formData.payment} 
                        onChange={handleChange}
                        >
                            {payment.map(opt => (
                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                        </select>
                        </div>
                            <div>
                        <label>Future Tasks:</label>
                        <select name="future_tasks" value={formData.future_tasks} 
                        onChange={handleChange}
                        >
                            {futureTasks.map(opt => (
                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                        </select>
                 </div>
                <div className=''>
                    <label htmlFor="start_date">Start Date:</label>
                    <DatePicker
                      ref={startDateRef}
                      selected={formData.start_date_obj}
                     onChange={(date) => { handleDateChange(date, 'start_date');
                        
                      setTimeout(() => {
                                const input = startDateRef.current?.input;
                                if (input) {
                                  const len = input.value.length;
                                  input.setSelectionRange(len, len);
                                }
                              }, 0);
                    }}
                    id="start_date"
                    name="start_date" 
                    className=""
                    // required
                    />   
                  {formErrors.start_date && (
                    <div className="error">{formErrors.start_date}</div>
                  )}                 
                </div>
                <div className=''>
                    <label htmlFor="end_date">End Date:</label>
                    <DatePicker
                    ref={endDateRef}
                    selected={formData.end_date_obj}
                    onChange={(date) => { handleDateChange(date, 'end_date');
                       setTimeout(() => {
                                const input = endDateRef.current?.input;
                                if (input) {
                                  const len = input.value.length;
                                  input.setSelectionRange(len, len);
                                }
                              }, 0);
                    }}
                    id="end_date"
                    name="end_date"
                    className=""
                    // required
                    />  
                  {formErrors.end_date && (
                    <div className="error">{formErrors.end_date}</div>
                  )}                 
                </div>
                <div className=''>
                    <label htmlFor="birthday_start_date">Birthdate Start Date:</label>
                    <DatePicker
                    ref={BirthstartDateRef}
                    selected={formData.birthday_start_date_obj}
                    onChange={(date) => {handleDateChange(date, 'birthday_start_date');
                       setTimeout(() => {
                                const input = BirthstartDateRef.current?.input;
                                if (input) {
                                  const len = input.value.length;
                                  input.setSelectionRange(len, len);
                                }
                              }, 0);
                    }
                    }
                    id="birthday_start_date"
                    name="birthday_start_date"
                    className=""
                    />                   
                </div>
                <div className=''>
                    <label htmlFor="birthday_end_date">Birthdate End Date:</label>
                    <DatePicker
                    ref={BirthendDateRef}
                    selected={formData.birthday_end_date_obj}
                    onChange={(date) => {handleDateChange(date, 'birthday_end_date');
                       setTimeout(() => {
                                const input = BirthendDateRef.current?.input;
                                if (input) {
                                  const len = input.value.length;
                                  input.setSelectionRange(len, len);
                                }
                              }, 0);
                    }}
                    id="birthday_end_date"
                    name="birthday_end_date"
                    className=""
                    />                   
                </div>
                <div className="">
                          <input type="submit" value="Submit" className="form-submit"  />&nbsp; &nbsp;
                           <input type="button" value="Export" className="form-submit"  onClick={handleExport}/>&nbsp; &nbsp;
                           <a href="/admin/reports/apps_by_country"><input type="button" name="" value="Clear" class="form-submit" /></a>
                      </div>
                 </form>
                 {submittedData && (
                  <>
                 <div id="total_apps">Total Apps: {rowCount}</div>
                 
                 <div className="apps-by-country-course-date-table">
                                           <table className="">
                                                <div style={{ width: '100%' }}>
                                                <DataGrid
                                                rows={rows}
                                                columns={columns}
                                                rowCount={rowCount}
                                                paginationMode="server"
                                                sortingMode="server"
                                                filterMode="server"
                                                // paginationModel={paginationModel}
                                                // onPaginationModelChange={setPaginationModel}
                                                paginationModel={{ pageSize: paginationModel.pageSize }}
                                                onPaginationModelChange={(model) => setPaginationModel(model)}
                                                sortModel={sortModel}
                                                onSortModelChange={setSortModel}
                                                filterModel={filterModel}
                                                onFilterModelChange={setFilterModel}
                                                pageSizeOptions={[5, 10, 25,50]}
                                                getRowId={() => crypto.randomUUID()}
                                                getRowHeight={() => 'auto'}
                                                disableColumnFilter 
                                                //disableColumnResize={true}
                                            />
                                               </div>
                                            </table>
                                            </div>
                                            {renderPaginationControls()}
                                            </>
                 )}
</div>
            </div>
            <div className="right">
                 
            </div>
        </div>
               )}
    </>
    );
};
export default AppsByCountry;